export default __webpack_public_path__ + "static/favicon-f2de94de14999fd9ffc035da390eba42.png";